import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import SkuMappingList from '../entities/skumapping-list'
import appconst from '@/lib/appconst';


interface SkuMappingState extends ListState<SkuMappingList> {
    stockmodel: SkuMappingList,

}

class FrontStockMutations extends ListMutations<SkuMappingList>{

}
class SkuMapping extends ListModule<SkuMappingState, any, SkuMappingList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<SkuMappingList>(),
        loading: false,
        stockmodel: SkuMappingList,
        id: 0
    }
    actions = {
        //async getAll(context: ActionContext<SkuMappingState, any>, payload: any) {
        //    context.state.loading = true;
        //    let reponse = await Ajax.get('/api/services/app/FrontStock/GetStockList', { params: payload.data });
        //    context.state.loading = false;
        //    let page = reponse.data.result as PageResult<SkuMappingList>;
        //    context.state.totalCount = page.totalCount;
        //    context.state.list = page.items;

        //},
        async Add(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontSkuMapping/Add', payload.data);
        },
        //async supplementStockInfo(state: any, payload: any) {
        //    let rep = await Ajax.post('/api/services/app/FrontStock/SupplementStockInfo', payload.data);
        //},

    };
    mutations = {
        setCurrentPage(state: SkuMappingState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SkuMappingState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const sku = new SkuMapping();
export default sku;